import styled from 'styled-components';
import { Card as CardEl } from '@veeqo/ui';

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--snow);

  > div {
    width: 50%;
    height: 50%;
    display: flex;

    > div {
      width: 100%;
    }
  }
`;

export const Card = styled(CardEl)`
  section {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: calc(100% - 48px);
    text-align: center;
  }
`;
